import { registerLocaleData } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import en from '@angular/common/locales/en';
import es from '@angular/common/locales/es';
import { inject, isDevMode } from '@angular/core';
import { type Translation } from '@jsverse/transloco';
import { type Observable } from 'rxjs';

registerLocaleData(es, 'es');
registerLocaleData(en, 'en');

class Loader {
  private readonly http = inject(HttpClient);

  getTranslation(lang: string): Observable<Translation> {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`, { params: { v: Math.random() } });
  }
}

export const localizationConfig = {
  config: {
    availableLangs: ['en', 'es'],
    defaultLang: 'en',
    reRenderOnLangChange: true,
    prodMode: !isDevMode(),
    preload: true,
  },
  loader: Loader,
};
